import "./Aboutus.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsArrowRight, BsArrowLeft, BsDot } from "react-icons/bs";
import { useRef } from "react";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import introVideo from "../videos/Home-banner.mp4";

export const Aboutus=()=>{

      const aboutUsslider01Ref = useRef(null);

      const aboutUsslider02Ref = useRef(null);

      const bannerRef = useRef(null);

      var banner_slider_settings = {
        className: "aboutus-banner-slider-component",
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 1500,
        slidesToShow: 2.7,
        slidesToScroll: 1,
        arrows: false,
      };

     var aboutUs_slider01_settings = {
       className: "about-us-page-mission-vision-section-slider-component",
       dots: false,
       infinite: true,
       speed: 500,
       autoplay: false,
       autoplaySpeed: 1500,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       nextArrow: <Slider01NextArrow />,
       prevArrow: <Slider01PrevArrow />,
     };

     var aboutUs_slider02_settings = {
       className: "aboutus-testimonial-slider-component",
       dots: false,
       infinite: true,
       speed: 500,
       autoplay: false,
       autoplaySpeed: 1500,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       nextArrow: <Slider02NextArrow />,
       prevArrow: <Slider02PrevArrow />,
     };

    const handleSlider_01_NextClick = () => {
      aboutUsslider01Ref.current.slickNext();
    };

    function Slider01NextArrow() {
      return (
        <BsArrowRight
          className="aboutus-slider01-nextarrow"
          onClick={handleSlider_01_NextClick}
        />
      );
    }

    const handleSlider_01_PrevClick = () => {
      aboutUsslider01Ref.current.slickPrev();
    };

    function Slider01PrevArrow() {
      return (
        <BsArrowLeft
          className="aboutus-slider01-prevarrow"
          onClick={handleSlider_01_PrevClick}
        />
      );
    }

    function Slider02NextArrow() {
      return (
        <BsArrowRight
          className="aboutus-slider02-nextarrow"
          onClick={handleSlider_02_NextClick}
        />
      );
    }

    function Slider02PrevArrow() {
      return (
        <BsArrowLeft
          className="aboutus-slider02-prevarrow"
          onClick={handleSlider_02_PrevClick}
        />
      );
    }

    const handleSlider_02_NextClick = () => {
      aboutUsslider02Ref.current.slickNext();
    };

    const handleSlider_02_PrevClick = () => {
      aboutUsslider02Ref.current.slickPrev();
    };

  return (
    <div id="about-us-page-main-wrapper">
      <div id="aboutus-banner-section-wrap">
        <div id="aboutus-banner-section-media-wrap">
          <Video autoplay loop id="banner-video">
            <source src={introVideo} type="video/webm" />
          </Video>
        </div>
        <div id="aboutus-banner-section-text-wrap">
          <div id="aboutus-banner-section-text-01">VIHARI PROJECT</div>
          <div id="aboutus-banner-section-text-03">10 years of experience</div>
        </div>

        <div id="aboutus-banner-section-slider-wrap">
          <Slider ref={bannerRef} {...banner_slider_settings}>
            <div className="aboutus-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza01.jpg" alt="" />
            </div>

            <div className="aboutus-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza02.jpeg" alt="" />
            </div>

            <div className="aboutus-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza03.jpeg" alt="" />
            </div>
          </Slider>
        </div>
      </div>

      <div id="about-us-page-about-us-section-wrap">
        <div id="about-us-page-about-us-section-title">About Us</div>
        <div id="about-us-page-about-us-section-content-para-01">
          We have been a key player in the real estate market for more than ten
          years. Due to our significant expertise and thorough comprehension of
          the real estate dynamic, our brand is synonymous with dependability
          and trustworthiness.
        </div>
        <div id="about-us-page-about-us-section-content-para-02">
          The Vihari Group is well known for its commitment to its customers. We
          are adamant that all procedures and rules necessary for a secure
          acquisition of our properties be followed.
        </div>
        <div id="about-us-page-about-us-section-content-para-02">
          Farmlands and plots owned by the partnership have all acquired
          TS-RERA, DTCP, and HMDA approval. Time value is very important to us.
          In order to expedite the procedures involved in purchasing properties,
          we finish our work on time.
        </div>
        <div id="about-us-page-about-us-section-background-image-fill-wrap">
          <img
            src="./Home-img/project-bg01.png"
            alt=""
            id="about-us-page-about-us-section-background-image-fill"
          />
        </div>
      </div>

      <div id="about-us-page-about-us-section-background-image01-fill-wrap">
        <img
          src="./Home-img/project-bg02.jpeg"
          alt=""
          id="about-us-page-about-us-section-background-image01-fill"
        />
      </div>

      <div id="about-us-page-mission-vision-section-slider-container">
        <Slider ref={aboutUsslider01Ref} {...aboutUs_slider01_settings}>
          <div>
            <div className="about-us-page-mission-vision-section-slider-title">
              Our Mission
            </div>
            <div className="about-us-page-mission-vision-section-slider-content">
              We intend to expand our business operations across the states of
              Telangana and Andhra Pradesh. Our goal is to offer our customers
              quality, safety, security, and legality. High investment return
              rate. We offer reasonably priced, elegant home plots to our
              consumers.
              <br /> Some examples of projects that have been approved are DTCP,
              HMDA with TS-RERA Layout, and Farmland Ventures.
            </div>
          </div>

          <div>
            <div className="about-us-page-mission-vision-section-slider-title">
              Our Vision
            </div>
            <div className="about-us-page-mission-vision-section-slider-content">
              We intend to expand our business operations across the states of
              Telangana and Andhra Pradesh. Our goal is to offer our customers
              quality, safety, security, and legality. High investment return
              rate. We offer reasonably priced, elegant home plots to our
              consumers. <br /> Some examples of projects that have been
              approved are DTCP, HMDA with TS-RERA Layout, and Farmland
              Ventures.
            </div>
          </div>
        </Slider>
      </div>

      <div id="aboutus-know-our-md-chairman-section-wrap">
        <div id="aboutus-know-our-md-chairman-section-image-fill-wrap">
          <img
            src="./Home-img/project-bg01.png"
            alt=""
            id="aboutus-know-our-md-chairman-section-image"
          />
        </div>
        <div id="aboutus-know-our-md-chairman-section-title">
          Get to know Our M.D. & Chairman
        </div>
        <div id="aboutus-know-our-md-chairman-section-sub-title">
          Jyothi Chowdary Katragadda
        </div>
        <div id="aboutus-know-our-md-chairman-section-content-para-01">
          Vihari Group was established with the goal of making a big impact on
          the Indian real estate industry & developing successful ventures by
          taking advantage of countries market opportunities for the benefit of
          all investors. We want to give top real estate options & exemplary
          advice to clients around the world so they may make wise investment
          choices. We’re a corporate real estate firm with an extremely skilled
          & motivated workforce.
        </div>
        <div id="aboutus-know-our-md-chairman-section-content-para-02">
          Our important advantages in carrying out a project successfully are
          our extensive experience in the real estate sector & our aptitude for
          reading the shifting market dynamics. As a company, Vihari group has
          an ingrained confidence in its basic values, which serve as a roadmap
          for our staff & management at every turn. Customers are our most
          valuable resource. every step we take is geared on providing them with
          superior service & forming a rewarding long-term relationship. We
          cordially invite you all to join the Vihari Group & eagerly look
          forward to working with you.
        </div>
        <div id="aboutus-know-our-md-chairman-section-content-para-03">
          Customers are our most valuable resource. every step we take is geared
          on providing them with superior service & forming a rewarding
          long-term relationship. We cordially invite you all to join the Vihari
          Group & eagerly look forward to working with you.
        </div>
      </div>
      <hr id="aboutus-know-our-md-chairman-section-divider" />

      <div id="aboutus-page-passionate-about-work-section-wrap">
        <div id="aboutus-page-passionate-about-work-section-title">
          We are passionate about work
        </div>
        <div id="aboutus-page-passionate-about-work-section-content">
          Everyone adores that magical moment when a project provides them with
          a need-filling opportunity. It has a magical sense, and Vihari
          Projects is dedicated to providing you with this experience in
          choosing the lands of your choice.
        </div>
        <div id="aboutus-page-passionate-about-work-section-grid-content-wrap">
          <div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-count">
              6 +
            </div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-text">
              Projects
            </div>
          </div>
          <div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-count">
              3500 +
            </div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-text">
              Happy Customers
            </div>
          </div>
          <div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-count">
              100 +
            </div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-text">
              Acres in Farmlands
            </div>
          </div>
          <div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-count">
              100 +
            </div>
            <div className="aboutus-page-passionate-about-work-section-grid-content-text">
              Acres in Residential Lands
            </div>
          </div>
        </div>
      </div>

      <div id="aboutus-page-email-section-container">
        <div id="aboutus-page-email-section-main-wrap">
          <div id="aboutus-page-email-section-sub-wrap">
            <div id="aboutus-page-email-section-logo-title-wrap">
              <div id="aboutus-page-email-section-logo-wrap">
                <img
                  src="./logo01.png"
                  alt="logo"
                  id="aboutus-page-email-section-logo"
                />
              </div>
              <div id="aboutus-page-email-section-title">VIHARI PROJECTS</div>
            </div>
            <div id="aboutus-page-email-section-text">
              Start a new investment with vihari projects{" "}
            </div>

            <div id="aboutus-page-email-section-input-wrap">
              <input
                type="text"
                id="aboutus-page-email-section-input-element"
                placeholder="Enter your email id"
              />
              <BsArrowRight id="aboutus-page-email-section-input-enter-icon" />
            </div>
          </div>
        </div>
      </div>

      <div id="aboutus-testimonial-section-wrap">
        <div id="aboutus-testimonial-section-headline">
          Encouraging words from our customers
        </div>
        <Slider ref={aboutUsslider02Ref} {...aboutUs_slider02_settings}>
          <div className="aboutus-testimonial-slider-content-wrap">
            <div className="aboutus-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aboutus-testimonial-slider-content-user-name">
              <BsDot className="aboutus-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>

          <div className="aboutus-testimonial-slider-content-wrap">
            <div className="aboutus-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image01"
                />
              </div>
              <div>
                Good and awesome projects. Really it's connecting to both nature
                and luxury style living. In short eco friendly projects. And
                they are very much cooperative
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aboutus-testimonial-slider-content-user-name">
              <BsDot className="aboutus-testimonial-slider-content-user-name-dot-icon" />{" "}
              Ansuman Tripathy
            </div>
          </div>

          <div className="aboutus-testimonial-slider-content-wrap">
            <div className="aboutus-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aboutus-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aboutus-testimonial-slider-content-user-name">
              <BsDot className="aboutus-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
}